<template>
  <div class="header-bottom wide-header" :class="{ isClosed: marketClosed }">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="search-path" :class="leftBlockClasses">
          <div class="h3 single-items pr-lg-4">
            <span
              class="text"
              @click="initSearch()"
              :style="{ 'font-size': currentTickerFontSize }"
              >{{ currentTicker }}</span
            >
            <button
              class="btn btn-filter-item"
              type="button"
              @click="initSearch(true)"
            >
              <icon-close />
            </button>
          </div>
        </div>
        <div class="px-0" :class="tickerClasses">
          <ticker-display />
        </div>
        <div :class="rightBlockClasses">
          <div class="single-items text-right">
            <ModalBuy />
            <market-selector
              class="border-left border-left-sm market-selector-header"
            />
          </div>
        </div>
      </div>
    </div>

    <ticker-search
      :searchOpened="searchOpened"
      ref="searchEl"
      @unfocused="
        () => {
          searchOpened = false
        }
      "
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TickerDisplay from './TickerDisplay'
import MarketSelector from './MarketSelector'
import TickerSearch from './TickerSearch'
import ModalBuy from './ModalBuy'
import iclose from '@/components/icons/closecircle'
import moment from 'moment'

export default {
  components: {
    'icon-close': iclose,
    'ticker-display': TickerDisplay,
    'market-selector': MarketSelector,
    'ticker-search': TickerSearch,
    ModalBuy,
  },
  data() {
    return {
      searchOpened: false,
      searchString: '',
      timestamp: '',
    }
  },
  methods: {
    initSearch(clearSearch = true) {
      this.$refs.searchEl.initSearch(clearSearch ? '' : this.currentTicker)
      this.searchOpened = true
    },
    getNow: function() {
      this.timestamp = moment().format('HH:mm:ss')
    },
  },
  computed: {
    ...mapState({
      settingsOpened: (state) => state.layout.settingsOpened,
      marketClosed: (state) => !state.market.trading,
      currentTicker: function(state) {
        if (state.market.companyName !== 'loading')
          return `${state.market.companyName}${
            state.market.tickerTypeVisible
              ? ' ' +
                this.$t(
                  'tickerTypes.' + state.market.tickerType || 'comm_stock'
                )
              : ''
          } (${state.market.ticker})`
        else return this.$t('messages.loading')
      },
      // TODO: change marketTz to tzOffset
      openTime: (state) =>
        `${state.market.openTime} ${moment
          .tz(state.market.marketTz)
          .format('z')}`,
    }),
    currentTickerFontSize() {
      if (this.currentTicker.length < 16) return
      return `${1 - (this.currentTicker.length - 16) * 0.023}em`
    },
    tickerClasses() {
      return 'col-lg-12 col-xl-4 order-xl-2 order-lg-2 order-md-3 order-sm-3 order-xs-3'
    },
    rightBlockClasses() {
      return 'col-xs-4 col-sm-4 col-md-5 col-lg-3 col-xl-3 order-1 order-xl-3'
    },
    leftBlockClasses() {
      return 'col-sm-8 col-md-7 col-lg-9 col-xl-5 order-lg-1 col-xs-7'
    },
  },
  created() {
    this.getNow()
    this.intID = setInterval(this.getNow, 1000)
  },
  beforeDestroy() {
    clearInterval(this.intID)
  },
}
</script>

<style lang="scss">
.header-bottom {
  background: #fff;
  padding: 6px 0;
  height: 64px;
  box-shadow: inset 0px -1px 0px #d1d1de;
  @include transition();
  position: relative;

  &:hover {
    box-shadow: inset 0px -1px 0px $primary-color2;
  }

  @media (max-width: 1200px) {
    padding: 10px 0;
    height: auto;
  }

  #SuggestionFilter {
    background: #ffff;
    border-top: 1px solid $primary-color2;
    position: absolute;
    width: 100%;
    top: 100%;
    height: 0;
    left: 0;
    @include transition();
    overflow: hidden;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 0px 4px 16px rgba(0, 0, 0, 0.16);

    a {
      color: #000;
      font-family: $primary-font;
      font-style: normal;
      font-weight: normal;
      display: block;
      font-size: 1.23rem;
      line-height: 2.46rem;

      &:hover {
        color: $primary-color2;
      }

      .grey {
        color: $text-color;
        font-size: 0.7em;
        min-width: 57px;
        vertical-align: bottom;
      }
      img {
        vertical-align: middle;
        padding-bottom: 3px;
        width: 20px;
      }

      > span {
        margin-right: 15px;
        min-width: 55px;
        display: inline-block;
      }

      @media (min-width: 575.99px) {
        font-size: 1.5rem;
        line-height: 2.5rem;
        > span {
          min-width: 75px;
        }

        .grey {
          min-width: 92px;
        }
      }
    }
    &.suggestionsOpened {
      height: auto;
      overflow: inherit;
      padding: 10px 0;
    }
  }

  .single-items {
    position: relative;
    margin: 0;
    display: block;
    display: flex;

    &.border-right {
      @media (max-width: 991px) {
        border-color: transparent !important;
      }
    }

    &.text-center {
      @media (max-width: 1199px) {
        justify-content: flex-start;
      }
    }
    &.text-right {
      @media (min-width: 575.99px) {
        justify-content: flex-end;
      }
    }
    .currency-area {
      display: inline-block;
      vertical-align: middle;

      .currency-item {
        display: block;
      }
      .icon {
        display: inline-block;
        margin-right: 10px;
      }
      .line-br {
        width: 1px;
        height: 34px;
        background-color: #c2c2d6;
        display: inline-block;
        margin: 8px 10px;
      }
      .block-text {
        font-family: $primary-font;
        font-style: normal;
        font-weight: normal;
        font-size: 0.75rem;
        line-height: 0.875rem;
        margin-right: 10px;

        span {
          display: block;
        }
      }

      .h4 {
        display: flex;
        margin: 0;
        align-items: center;
        font-family: $primary-font;
        font-style: normal;
        font-weight: normal;
        font-size: 2rem;
        line-height: 2.5rem;

        @media (max-width: 1366px) {
          font-size: 1.5rem;
          line-height: 1.5rem;
        }

        .right-text {
          font-size: 0.75rem;
          line-height: 0.875rem;
          margin-bottom: 0;
          margin-left: 10px;
          text-align: left;
        }
      }
    }

    span.faq-icon {
      cursor: pointer;
      background: none !important;
      outline: none !important;
      border: none !important;

      &:hover svg path {
        stroke: $primary-color2;
      }
    }

    &.border-right,
    &.border-left {
      border-width: 1px;
      border-color: #c2c2d6;
    }

    &.h3 {
      font-family: $primary-font;
      font-style: normal;
      font-weight: bold;
      font-size: 2rem;
      line-height: 2.5rem;
      color: #000;

      @media (max-width: 767px) {
        font-size: 1.5rem;
      }
    }
  }

  .single-header-info {
    text-align: right;

    @media (max-width: 991px) {
      text-align: center;
    }

    p {
      color: #373833;
      font-weight: 600;
      display: inline-block;
      margin-bottom: 0;
    }

    a {
      display: inline-block;
      background: $primary-color;
      font-size: 0.875rem;
      line-height: 2.5rem;
      padding: 0 20px;
      border-radius: 50px;
      color: #fff;
      margin-left: 20px;
    }
  }
}

.svg-hover {
  &:hover {
    cursor: pointer;
    path {
      stroke: $primary-color2;
    }
  }
}

.NoDeal {
  .currency-animated .icon {
    display: none !important;
  }
  .right-text {
    color: #8a8a8a !important;
  }
  .currency-animated:hover {
    .currency-item-1 {
      display: block !important;
    }
    .currency-item-2 {
      display: none !important;
    }
  }
  .currency-item-2 {
    display: none !important;
  }
}

.wide-header {
  .col-lg-5 {
    flex: 0 0 36.666667%;
    max-width: 36.666667%;

    @media (max-width: 1199px) {
      flex: 1 1 59%;
      max-width: 100%;
    }
    .single-items.text-center {
      justify-content: flex-end;
    }
    @media (max-width: 991px) {
      flex: 0 0 100%;
      max-width: 100%;

      .single-items.text-center {
        justify-content: center;
      }
    }
  }

  .close-text {
    color: #f9a400;
    font-weight: normal;
    font-size: 0.75rem;
    line-height: 0.875rem;
    text-align: left;
    min-width: 190px;
    margin-right: auto;

    span {
      display: inline-block;
    }
    @media (max-width: 575.98px) {
      span {
        display: inline-block;
      }
    }
  }
}

.isClosed {
  .icon svg path {
    stroke: #c2c2d6;
  }
  .right-text.h6,
  .low-text.text-black.h4 > span,
  .low-text .text-primary {
    color: #c2c2d6 !important;
  }
  .close-text {
    color: #f9a400;
    font-weight: normal;
    font-size: 0.75rem;
    line-height: 0.875rem;
    text-align: left;
    min-width: 190px;
    margin-right: auto;

    span {
      display: block;
      color: #000;
      line-height: 1rem;
    }
  }
}

.btn {
  &-settings {
    background-color: transparent;
    border: 0;
    position: relative;

    &:before {
      content: '';
      width: 100%;
      height: 100%;
      background-color: rgba(#fff, 0.7);
      position: fixed;
      right: 0;
      top: 0;
      z-index: -1;
      color: currentColor;
      cursor: not-allowed;
      text-decoration: none;
      pointer-events: none !important;
    }

    svg {
      &:first-child {
        display: block;
      }
      &:last-child {
        display: none;
      }
    }
    &[aria-expanded='true'] {
      z-index: 1;

      svg {
        &:first-child {
          display: none !important;
        }
        &:last-child {
          display: block !important;
        }
      }
    }
  }
  &-search {
    border: 0;
    width: 50px;
    position: relative;
    text-align: center;
    background-color: transparent;

    &:after {
      width: 1px;
      height: 20px;
      content: '';
      background-color: #c2c2d6;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &:hover svg path {
      stroke: $primary-color2;
    }
  }

  &-text {
    background-color: transparent;
    float: right;
    margin-top: -6px;
    font-size: 1.125rem;
    padding: 0;
  }
}

@media (max-width: 575.98px) {
  .header-bottom {
    padding: 0;
    box-shadow: none;

    .block-text {
      color: #8a8a8a;
    }
    .h4.low-text {
      font-size: 12px !important;
      line-height: 20px;
    }

    .search-path {
      box-shadow: inset 0px -1px 0px #d1d1de;

      .text {
        // search text itself
        font-size: 1.23rem;
        line-height: 3.07rem;
      }
      .btn {
        // clear search button
        position: absolute;
        right: 0;
        top: 4px;
        padding-right: 0;
      }
    }

    .border-left-sm {
      border-left: none !important;
    }

    .currency-area {
      padding-top: 14px;
    }

    .market-selector-header {
      #countries_child {
        left: -11px;
      }
    }
  }
}
</style>
